import { useState } from 'react';
import { toast } from 'react-toastify';
import { useQueryClient } from '@tanstack/react-query';

import axios from "axios";
import config from '../../config';

import '../../styles/buttons.css';
import '../../styles/popup.css';

import imageUpload from '../general/imageUpload';

import TextField from '@mui/material/TextField';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { message, Upload } from 'antd';
import { PlusOutlined } from '@ant-design/icons';


const AddAnnouncementForm = ({ onClose, selectedAccount, selectedProperty }) => {
  const [title, setTitle] = useState('');
  const [content, setContent] = useState('');
  const [expiry, setExpiry] = useState(null);
  
  const queryClient = useQueryClient();

  const [announcementImage, setAnnouncementImage] = useState(null);

  const handleSubmit = async (e) => {
  e.preventDefault();
  try {
    let imageIds = [];
    if (announcementImage) {
      imageIds = await imageUpload(
        [announcementImage].map(f => ({ name: f.name, type: f.type, data: f})),   
        "announcement",       
        selectedProperty.value,
        selectedAccount,
        ["announcement image"] 
      );
    }

    await axios.post(
      `${config.API_URL}/v2/announcement`,
      {
        accountId: selectedAccount,
        property: selectedProperty.value,
        announcementTitle: title,
        announcement: content,
        expiry: expiry ? expiry.toDate().toISOString() : null,
        images: imageIds,
      },
      {headers: {Authorization: `Bearer ${localStorage.getItem('accessToken')}`}}
    );

    queryClient.invalidateQueries(['announcements']);
    toast.success("Announcement created successfully!");
    onClose();
  } catch (error) {
    console.error("Failed to create announcement", error);
    toast.error("Failed to create announcement.");
  }
};

  return (
    <div className="popup-overlay">
      <div className="popup-content">
        <button className="close-popup" onClick={onClose}>
          <i className="fas fa-times"></i>
        </button>
        <h2 className="text-2xl text-black">Add Announcement</h2>
        <form onSubmit={handleSubmit}>
          <div className="announcement-img-upload" style={{ display: 'flex', justifyContent: 'center', marginBottom: '1rem' }}>
            <Upload
              name="announcement"
              listType="picture-card"
              className="announcement-uploader"
              showUploadList={false}
              beforeUpload={(file) => {
                const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png';
                if (!isJpgOrPng) {
                  message.error('You can only upload JPG/PNG file!');
                  return Upload.LIST_IGNORE;
                }
                const isLt2M = file.size / 1024 / 1024 < 2;
                if (!isLt2M) {
                  message.error('Image must be smaller than 2MB!');
                  return Upload.LIST_IGNORE;
                }
                setAnnouncementImage(file);
                return false; // prevent actual upload
              }}
            >
              {announcementImage ? (
                <div style={{ position: "relative" }}>
                  <img
                    src={URL.createObjectURL(announcementImage)}
                    alt="announcement"
                    style={{ width: "100%" }}
                  />
                  <button
                    type="button"
                    onClick={(e) => {
                      e.stopPropagation();
                      setAnnouncementImage(null); // clear image
                    }}
                    style={{
                      position: "absolute",
                      top: 4,
                      right: 4,
                      background: "rgba(0,0,0,0.5)",
                      color: "#fff",
                      border: "none",
                      borderRadius: "50%",
                      cursor: "pointer",
                      width: 22,
                      height: 22,
                    }}
                  >
                    <i className="fas fa-times"></i>
                  </button>
                </div>
              ) : (
                <button style={{ border: 0, background: "none" }} type="button">
                  <PlusOutlined />
                  <div style={{ marginTop: 4 }}>Upload<br />JPG/PNG, max 2MB</div>
                </button>
              )}
              </Upload>
          </div>
          <TextField
            label="Title"
            value={title}
            onChange={(e) => setTitle(e.target.value)}
            fullWidth
            style={{ marginBottom: '1rem' }}
          />
          <TextField
            label="Content"
            value={content}
            onChange={(e) => setContent(e.target.value)}
            multiline
            rows={4}
            fullWidth
            style={{ marginBottom: '1rem' }}
          />
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
              label="Expiry Date"
              value={expiry}
              onChange={(newVal) => setExpiry(newVal)}
              renderInput={(params) => <TextField {...params} />}
              sx={{ width: '100%', marginBottom: '1rem' }}
            />
          </LocalizationProvider>
          <div className="form-buttons">
            <button type="submit" className="button">Add Announcement</button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default AddAnnouncementForm;